import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { EnvironmentServiceProvider } from './../environment-service/environment-service';

@Injectable()
export class FacilityServicesProvider {

  constructor(
    public http: HttpClient,
    public envService: EnvironmentServiceProvider
  ) {}

  ///demo/idpClientDemo/v1/facilities/

  getFacilities(pageNumber: number = 1, pageSize: number = 10, facility): Observable<any>{
    let facilityParams = new HttpParams().append('PageNumber', pageNumber.toString()).append('PageSize', pageSize.toString()).append('FacilityName', facility)

    return this.http.get(this.envService.env.idpEndpoint + '/idpClient/v1/facilities/', {params: facilityParams})
  }

  getFacility(facilityId: number): Observable<any>{
    return this.http.get(this.envService.env.idpEndpoint + '/idpClient/v1/facilities/' + facilityId)
  }

  getLocations(pageNumber: number = 1, pageSize: number = 10, location): Observable<any>{
    let locationParams = new HttpParams().append('PageNumber', pageNumber.toString()).append('PageSize', pageSize.toString()).append('Description', location)
    return this.http.get(this.envService.env.idpEndpoint + '/idpClient/v1/locations/', {params: locationParams})
  }

  getFacilityLocations(facilityId: number): Observable<any> {
    let facilityParams = new HttpParams().append('facilityId', facilityId.toString())

    return this.http.get(this.envService.env.apiEndpoint + '/smp/cp/facility/v1/locations/' , {
      params: facilityParams,
      observe: 'response'
    })
  }

  getFacilityName(): Observable<any> {
    return this.http.get(this.envService.env.apiEndpoint + '/smp/cp/facility/v1/facility/' , {
      observe: 'response'
    })
  }

  getFacilityNameById(facilityId): Observable<any> {
    return this.http.get(this.envService.env.apiEndpoint + '/smp/cp/facility/v1/facility/'+ facilityId )
  }
}



// WEBPACK FOOTER //
// ./src/providers/facility-service/facility-service.ts